import type { ScaleLinear } from 'd3-scale';
import { useContext, createContext } from 'react';

import type {
  GanttChartConfig,
  GanttSegmentData,
} from '../types/gantt-chart.js';

type Context = {
  segmentsData: GanttSegmentData[];
  parentSegmentsData?: GanttSegmentData[];
  config: GanttChartConfig;
  hovering?: boolean;
  segmentScale?: ScaleLinear<number, number, never>;
};

export const GanttSegmentsContext = createContext<Context>({
  segmentsData: [],
  parentSegmentsData: undefined,
  config: { nameAccessor: 'name' },
  hovering: false,
});

export const useGanttSegmentsContext = (): Context =>
  useContext(GanttSegmentsContext);

GanttSegmentsContext['displayName'] = 'ganttSegmentsContext';
